module.exports = __webpack_public_path__ + "static/media/icono_promotor_inactivo.d15bffe2.svg";